import { render } from "./ShareAccessCodeSection.vue?vue&type=template&id=e8890eb4"
import script from "./ShareAccessCodeSection.vue?vue&type=script&lang=js"
export * from "./ShareAccessCodeSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__